import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {FinancialFilingContainerModel} from '../../../../../../models/aggregates/erp/financial-filing';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class FinancialFilingService extends BaseApiTemplateService<FinancialFilingContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'filings';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'filings';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'filings';
    this.httpClient = http;
  }

}


